import { dew as _package2Dew } from "./package";
import { dew as _configuration2Dew } from "./configuration";
import { dew as _plugins2Dew } from "./plugins";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "ROOT_CONFIG_FILENAMES", {
    enumerable: true,
    get: function () {
      return _configuration.ROOT_CONFIG_FILENAMES;
    }
  });
  Object.defineProperty(exports, "findConfigUpwards", {
    enumerable: true,
    get: function () {
      return _configuration.findConfigUpwards;
    }
  });
  Object.defineProperty(exports, "findPackageData", {
    enumerable: true,
    get: function () {
      return _package.findPackageData;
    }
  });
  Object.defineProperty(exports, "findRelativeConfig", {
    enumerable: true,
    get: function () {
      return _configuration.findRelativeConfig;
    }
  });
  Object.defineProperty(exports, "findRootConfig", {
    enumerable: true,
    get: function () {
      return _configuration.findRootConfig;
    }
  });
  Object.defineProperty(exports, "loadConfig", {
    enumerable: true,
    get: function () {
      return _configuration.loadConfig;
    }
  });
  Object.defineProperty(exports, "loadPlugin", {
    enumerable: true,
    get: function () {
      return _plugins.loadPlugin;
    }
  });
  Object.defineProperty(exports, "loadPreset", {
    enumerable: true,
    get: function () {
      return _plugins.loadPreset;
    }
  });
  Object.defineProperty(exports, "resolvePlugin", {
    enumerable: true,
    get: function () {
      return _plugins.resolvePlugin;
    }
  });
  Object.defineProperty(exports, "resolvePreset", {
    enumerable: true,
    get: function () {
      return _plugins.resolvePreset;
    }
  });
  Object.defineProperty(exports, "resolveShowConfigPath", {
    enumerable: true,
    get: function () {
      return _configuration.resolveShowConfigPath;
    }
  });

  var _package = _package2Dew();

  var _configuration = _configuration2Dew();

  var _plugins = _plugins2Dew();

  ({});
  return exports;
}